import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1744280477834/charger_kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1744280477626/charger_kv_h5.jpg',
        title: t('title'),
        desc: t('desc'),
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataA} />
        </div>
    );
}
